module.exports = __webpack_public_path__ + "static/img/3.4fc0a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/snip3down/3.png
// module id = oUD5
// module chunks = 35